module.exports = __webpack_public_path__ + "images/credit-cards/credit-card-amex.1256bb64c2e33bafad63.png";